<script>
import {PixabayImage} from "./PixabayImage";

export default {
    name: "PixabayImagePreview",
    props: {
        image: { type: PixabayImage, default: {}},
        selected: { type: Boolean, default: false },
        displaySize: { type: Boolean, default: false }
    },
    computed: {
        sizeText() {
            return this.formatBytes(this.image.size);
        }
    },
    methods: {
        formatBytes(bytes, decimals = 2) {
            if (bytes === 0) return '0 B';

            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];

            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }
    }
}
</script>

<template>
    <div
        class="pixabay-masonry-item"
        :class="{ selected }"
        @click="$emit('click', image)"
    >
        <div class="pixabay-masonry-img-wrapper">
            <img
                :src="image.getUrl('webformat')"
                :alt="'Pixabay image with id ' + image.id"
                class="pixabay-masonry-img"
            />

            <div class="hover-info">
                <div v-if="image.isAiGenerated" class="top-info">
                    {{ 'AI generated' }}
                </div>

                <div class="info-line">
                    {{ image.webformatHeight }}×{{ image.webformatWidth }}
                </div>

                <div v-if="displaySize">
                    {{ sizeText }}
                </div>

                <a
                    class="open-icon"
                    :href="image.pageURL"
                    target="_blank"
                    @click.stop
                >
                    <v-icon color="white" small>fal fa-square-arrow-up-right</v-icon>
                </a>
            </div>
        </div>
    </div>
</template>

<style scoped>
.pixabay-masonry-item {
    animation: fadeIn 0.3s ease;
    cursor: pointer;
    position: relative;
    padding: 8px;
}

.pixabay-masonry-img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 6px;
    transition: opacity .15s;
}

.pixabay-masonry-img:hover {
    opacity: .9;
}

.pixabay-masonry-item.selected .pixabay-masonry-img {
    outline: 3px solid #1976d2;
    outline-offset: 2px;
}

.pixabay-masonry-item.selected::after {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(25, 118, 210, 0.25);
    border-radius: 6px;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.pixabay-masonry-img-wrapper {
    position: relative;
}

.hover-info {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    color: white;
    opacity: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 6px 8px;
    font-size: 12px;
    border-radius: 6px;
    transition: opacity .15s ease;
}

.pixabay-masonry-item:hover .hover-info {
    opacity: 1;
}

.open-icon {
    color: white;
    display: flex;
    align-items: center;
    cursor: pointer;
    text-decoration: none;
}

.top-info {
    position: absolute;
    top: 6px;
    left: 8px;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.45);
    padding: 2px 6px;
    border-radius: 4px;
}
</style>
